module.exports = __webpack_public_path__ + "static/media/4.16.be4bc60c.png";